import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { authManagementService } from '@aviv-pro-navigation/authentication-core';
import { forkJoin, from, Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { FournisseurService } from './fournisseur.service';
import { LoaderService } from './loader.service';
import { NavigationService } from './navigation.service';
import { ReferenceService } from './reference.service';
import { RightsService } from './rights.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class InitializerGuard implements CanActivate {

  constructor(
    private loaderService: LoaderService,
    private referenceService: ReferenceService,
    private userService: UserService,
    private fournisseurService: FournisseurService,
    private navigationService: NavigationService,
    private rightsService: RightsService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (this.userService.isMonitoringMode()) {
      this.loaderService.increaseLoaderCount();
      return this.loadServices();
    }
    const baseUrl = this.referenceService.staticReferences.ApiDuoServer + this.referenceService.staticReferences.ApiDuoVersion;
    authManagementService.init(baseUrl);
    this.loaderService.increaseLoaderCount();

    return from(authManagementService.checkSession()).pipe(
      switchMap(() => this.loadServices()),
      catchError(() => {
        window.location.href = this.referenceService.staticReferences.DuoDomain + '?redirectTo=' +
          encodeURIComponent(3 + route['_routerState'].url);
        return throwError('Unauthorized error');
      })
    );


  }

  loadServices(): Observable<boolean> {
    const fournisseursInfos$ = this.fournisseurService.fetchFournisseurs();
    const userInfos$ = this.navigationService.fetchUserInfos();
    const navigationApps$ = this.navigationService.fetchNavigationApps();

    return forkJoin([fournisseursInfos$, userInfos$, navigationApps$]).pipe(map(
      ([fournisseursInfos, userInfos, navigationApps]) => {
        this.fournisseurService.initSuppliersInfos(fournisseursInfos);
        this.navigationService.setUserInfos(userInfos);
        this.navigationService.filteringTabBar(navigationApps);
        this.rightsService.refreshUserRights();
        this.loaderService.decreaseLoaderCount();
        return true;
      }
    ));
  }
}
